import { render, staticRenderFns } from "./cms-block-navigation.vue?vue&type=template&id=05b50f7c&scoped=true"
import script from "./cms-block-navigation.vue?vue&type=script&lang=js"
export * from "./cms-block-navigation.vue?vue&type=script&lang=js"
import style0 from "./cms-block-navigation.vue?vue&type=style&index=0&id=05b50f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b50f7c",
  null
  
)

export default component.exports